import React, { FunctionComponent, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { useMsal } from "@azure/msal-react"
import appService from "src/AppService"
import stateService from "src/utilities/AsyncStateManager/StateService"
import "./LoginBox.css"

const LoginBox: FunctionComponent<{}> = () => {
    const history = useHistory()
    const { authenticateWithPortalAPI } = appService
    const { updateState } = stateService
    const { instance } = useMsal()

    const handleLogin = () => {
        try {
            const loginRequest = {
                scopes: [
                    process.env.REACT_APP_MSAL_INSTANCE_SCOPES as string
                ]
            }

            instance.loginPopup(loginRequest)
                .then(res => {
                    authenticateWithPortalAPI(res.accessToken, history)
                }).catch((err) => {
                    console.error(err)
                    localStorage.clear()
                    updateState("appState", [
                        { key: "authenticated", value: false },
                    ])
                })
        } catch (err) {
            console.error(err)
            localStorage.clear()
            updateState("appState", [
                { key: "authenticated", value: false },
            ])
        }
    }

    return (
        <div className="LoginBox">
            <div className="LoginBoxUpper">
                <div id="a2d153de4706497ba8d1c3a538841ee0">LaunchPoint</div>
                <h1 id="hd1d61ea0ba4452f8a008bfdac4b52fb">Portal</h1>
                <div id="j5dfdd03d7224770a715e1ca2e1b45a9">SIGN IN</div>
            </div>
            <div className="LoginBoxLower">
                <div className="LoginBoxLoginButton" onClick={handleLogin}>
                    <img id="f7c6ebada145e68e4209b1b821e231" src="/res/swoosh.png" alt="LaunchPoint" />
                    <div id="g7c6ebada145e68e4209b1b821e231">Sign in with LaunchPoint</div>
                </div>
            </div>
        </div>
    )
}

export default LoginBox
